export const LOCALE_DE = {
    ORDER: "Bestellung",
    INVOICE: "Rechnung",
    INVOICES: "Rechnungen",
    PROFORMA_INVOICES: "Proformarechnungen",
    CREDIT_NOTE: "Gutschrift",
    CREDIT_NOTES: "Gutschriften",
    CREATION_DATE: "Ausstellungsdatum",
    DELIVERY_DATE: "Lieferdatum",
    DELIVERY_ADDRESS: "Lieferadresse",
    DELIVERY_COST: "Liefergebühr",
    VENDOR: "Lieferant",
    CUSTOMER: "Kunde",
    ORDER_NUMBER: "Bestellnummer",
    PAYMENT_METHOD: "Zahlungsmethode",
    NOTE: "Notiz",
    PRODUCT: "Artikel",
    PRODUCT_DESCRIPTION: "Beschreibung",
    PRODUCT_AMOUNT: "Menge",
    PRODUCT_SINGLE_PRICE: "Einzelpreis",
    DISCOUNT: "Rabatt",
    TOTAL_DISCOUNTS: "Gesamtrabatt",
    TOTAL_BEFORE_DISCOUNTS: "Gesamt vor Rabatt",
    TAX_ABBREVIATED: "USt.",
    TAX_AMOUNT: "Steuerbetrag",
    SPLIT_AMOUNT: "Anteil",
    BRUTTO: "Brutto",
    TOTAL: "Gesamt",
    TOTAL_INCLUDING_VAT: "Gesamt inkl. USt.",
    TOTAL_EXCLUDING_VAT: "Gesamt exkl. USt.",
    VAT_ID: "USt-IdNr.",
    TAX_ID: "SteuerNr.",
    PAID: "Bezahlt",
    UNPAID_AMOUNT: "Unbezahlter Betrag",
    REASON: "Grund",
    INVOICE_LINE_ITEMS_TITLE: "Bestellpositionen",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Gutschriften auf Bestellpositionen",
    OTHER_CREDIT_NOTES: "Anpassung der Bestellung",
    REFUND_SHIPPING_COST: "Rücksendungsgebühren",
    REFUND_HAS_BEEN_PAID: "Erstattung in Höhe von $VALUE wurde ausgezahlt.",
    REFUND_HAS_BEEN_PAID_FAILED: "Bei der Erstattung in Höhe von $VALUE ist ein Fehler aufgetreten.",
    DOCUMENTS_FOR_ORDER: "Dokumente zu Bestellung",
    NO_INVOICES: "Noch keine Rechnung vorhanden",
    NO_CREDIT_NOTES: "Noch keine Gutschriften vorhanden",
    DOCUMENTS_ARE_GENERATING:
        "Die Rechnungsdokumente werden derzeit erzeugt. Bitte versuchen sie es in ein paar Minuten nochmal.",
    INVALID_REQUEST_PATHWAY_SUPPORT:
        "Zu dieser Bestellung konnten keine Dokumente gefunden werden. Bitte wenden Sie sich an support@pathway-solutions.de",
    INVALID_REQUEST_GENERIC:
        "Zu dieser Bestellung konnten keine Dokumente gefunden werden. Bitte wenden Sie sich an den jeweiligen Händler.",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT:
        "Zu dieser Bestellung konnten keine Dokumente gefunden werden. Bitte wenden Sie sich an ${MAIL}",
    GIFT_CARD_LINE:
        "Bei dieser Bestellung wurde ein Gutscheincode${GIFT_CARD_CODE} über ${GIFT_CARD_AMOUNT} verwendet.",
    GIFT_CARD: "Gutschein",
    REVERSAL_INVOICE: "Stornorechnung",
    REVERSAL_CREDIT_NOTE: "Storno Gutschrift",
    DUTY: "Zoll",
    USED_DISCOUNTS: "Verwendete Rabatte",
    PAYMENT_AT: "Zahlung am $DATE",
    REFUNDED_CREDITNOTE_AT: `Rückzahlung der Gutschrift $CREDIT_NOTE am $DATE`,
    REFUNDED_AT: "Rückzahlung am $DATE",
    PROCESSING_DOCUMENT: "Dokument wird bearbeitet",
    DOWNLOAD_DOCUMENTS_TITLE: "Lade dir hier deine Dokumente herunter!",
    MAIL_INTRODUCTION: "Bei Fragen wende dich an ${MAIL}",
    REPAYMENT_DIFFERENCE: "Differenz zur Rückzahlung",
    DOCUMENT_PREVIEW_BANNER: "Vorschau – bitte PDF herunterladen",
};
